import type { QueryClient } from '@tanstack/react-query';
import type { getConfigByKey } from '@tn/configs';

import { runPostAuthClientSetup } from '../runPostAuthClientSetup';

type RunPostSignUpClientSetupParams = {
    queryClient: QueryClient;
    getConfigByKey: ReturnType<typeof getConfigByKey>;
};

/** Runs post-registration client steps after signUp succeeds and CBS_COM is set. */
export async function runPostSignUpClientSetup({
    queryClient,
    getConfigByKey,
}: RunPostSignUpClientSetupParams): Promise<void> {
    await runPostAuthClientSetup({
        queryClient,
        getConfigByKey,
        flow: 'signUp',
    });
}
